import "./App.css";
import "./style/main.scss";
import { OrderCard } from "./components";

function App() {
  return (
    <div className="App">
      <OrderCard />
    </div>
  );
}

export default App;
